import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Translation resources
const resources = {
  fr: {
    translation: {
      header: "Prenez rendez-vous avec un professionnel de santé en Mauritanie",
      search_placeholder: "Nom du médecin ou spécialité",
      popular_searches: "Recherches populaires",
      download_app: "Télécharger notre application",
      search_button_text: "Rechercher",
      hero_header: "Prenez rendez-vous avec un professionnel de santé",
      professional_healthcare: "Vous êtes professionnel de santé ?",
      help: "Aide",
      login: "Se connecter",
      loading: "Recherche en cours...",
      download_app_store: "Télécharger dans l'App Store",
      download_google_play: "Disponible sur Google Play",
      hero_background_alt: "Arrière-plan médical",
      certification_text: "Agréé par le ministère de la santé Nº: 00266/2021",
      appPromo: {
        header: "L'application n°1 pour votre santé",
        description: "Yata Medical rend l'accès aux soins rapide et facile.",
        rating: "Note : 4,7",
        download_ios: "Télécharger dans l'App Store",
        download_android: "Disponible sur Google Play",
        alt_ios: "Télécharger l'application Yata Medical depuis l'App Store",
        alt_android:
          "Télécharger l'application Yata Medical depuis Google Play",
        phone_alt: "Application mobile Yata Medical",
      },
      nosTrophees: {
        title: "-Nos Trophées-",
        total_award:
          "Prix du meilleure startup en Mauritanie à la 2ème édition du challenge STARUPPER DE L'ANNÉE organisée par TOTAL ENERGIE dans 52 pays.",
        ibtikar_award:
          "Élu l'entreprise la plus innovante en Mauritanie lors du challenge IBTIKAR-PRIZE organisée par le ministère de la transition numérique édition 2022.",
        alt_total: "Prix Total Energie Startupper",
        alt_ibtikar: "Prix Ibtikar",
      },
      aboutUs: {
        title: "Qui sommes-nous?",
        para1:
          "Fondée en 2018, YATA Médical est le prémier opérateur agree de télémédecine en Mauritanie.",
        para2:
          "Notre mission est de rendre les soins de santé accessibles à tous, en exploitant des innovations intelligentes et des outils technologiques de pointe. En mettant l'accent sur la démocratisation des services médicaux, nous avons développé une gamme complète d'outils de gestion hospitalière, offrant une solution intégrée pour améliorer l'efficacité des établissements de santé.",
      },
      healthcarePartner: {
        title: "Nos Partenaires de Santé",
        subtitle: "Un réseau de confiance",
        description:
          "Notre plateforme connecte les patients avec un vaste réseau de professionnels de santé qualifiés. Nous collaborons étroitement avec des médecins, des spécialistes et des établissements de santé pour offrir des soins de qualité supérieure à nos patients.",
        stats: [
          "médecins mauritaniens inscrits",
          "imagerie médicale uploadée en ligne",
          "consultations",
          "Support disponible",
        ],
        alt: "Professionnels de santé partenaires",
      },
      success: {
        title: "Compte créé avec succès.",
        buttons: {
          install: "Télécharger l’application",
        },
      },

      inscription: {
        stepCounter: {
          currentStep: "Étape {{currentStep}} sur {{totalSteps}}",
        },
        newTitle: "Création du compte",
        title: "S'inscrire",
        passwordTips:
          "💡 Conseils: Utilisez au moins 8 caractères, incluez des majuscules, des chiffres et des symboles",
        datepicker: {
          placeholder: "Sélectionnez votre date de naissance",
          done: "Terminé",
          cancel: "Annuler",
          months: [
            "Janvier",
            "Février",
            "Mars",
            "Avril",
            "Mai",
            "Juin",
            "Juillet",
            "Août",
            "Septembre",
            "Octobre",
            "Novembre",
            "Décembre",
          ],
        },
        termsTitle: "Conditions d'utilisation et Politique de confidentialité",
        close: "Fermer",
        iAccept:
          "J’accepte les conditions d’utilisation et la politique de confidentialité.",
        accept: "Accepter",
        decline: "Refuser",
        termsAccepted: "Vous devez accepter les conditions.",
        termsMustAccept: " Vous devez accepter les conditions.",
        PRIVACY_TEXT: `✅ Avis de confidentialité & Consentement éclairé de l’utilisateur
        
        Responsable du traitement
        
        YATA MEDICAL & SCIENCE SARL, société enregistrée sous le numéro 96819/GU/17828, ayant son siège à SOCO 0279, Nouakchott, est responsable du traitement des données à caractère personnel collectées via cette application.
        
        ⸻
        
        Finalités du traitement
        
        Nous collectons et traitons vos données personnelles pour vous fournir des services de santé numériques, notamment :
          •	La prise de rendez-vous médicaux en ligne et en cabinet ;
          •	La téléconsultation et la télé-expertise ;
          •	Le suivi des constantes de santé et la gestion de votre dossier médical informatisé (DMP) ;
          •	La communication sécurisée avec les professionnels de santé autorisés.
        
        ⸻
        
        Données collectées
        
        Les données susceptibles d’être traitées incluent :
          •	Données d’identification : nom, prénom, téléphone, e-mail ;
          •	Données de santé : antécédents médicaux, symptômes, résultats d’examens, constantes biométriques, traitements.
        
        ⸻
        
        Base légale & consentement
        
        Conformément à la loi n° 2017-020 :
          •	Vos données ne seront traitées qu’avec votre consentement libre, spécifique, éclairé et univoque.
          •	En cliquant sur “J’accepte”, vous autorisez expressément le traitement de vos données pour les finalités mentionnées ci-dessus.
          •	Vous pouvez retirer votre consentement à tout moment, sans justification, via l’onglet “Contact” ou en nous écrivant à : support@yatamedical.com
        
        ⸻
        
        Destinataires des données
        
        Vos données sont accessibles uniquement :
          •	Aux professionnels de santé que vous autorisez expressément via notre système d’authentification (OTP ou QR code) ;
          •	Au personnel technique habilité de YATA Medical pour des besoins de maintenance ou support.
        
        Aucune donnée n’est partagée avec des tiers non autorisés, sauf obligation légale.
        
        ⸻
        
        Transferts & hébergement
        
        Les données sont hébergées de manière sécurisée dans des centres de données certifiés :
          •	En Mauritanie (sauvegarde) ;
          •	En Allemagne (DigitalOcean & Hetzner) pour la production, le stockage sécurisé et la redondance.
        
        ⸻
        
        Durée de conservation
        
        Vos données de santé sont conservées pendant 10 ans, conformément aux normes nationales. Passé ce délai, elles sont anonymisées ou supprimées.
        
        ⸻
        
        Vos droits
        
        Vous pouvez à tout moment :
          •	Accéder à vos données,
          •	Les modifier ou les supprimer,
          •	Vous opposer à leur traitement.
        
        Pour exercer ces droits, contactez notre service client :
          •	📞 Téléphone : +222 244 00 001
          •	📧 Email : support@yatamedical.com
        
        ⸻
        
        Sécurité des données
        
        Nous appliquons des mesures de sécurité strictes :
        🔐 Authentification forte, 🔐 chiffrement des données, 🔒 contrôle des accès, 📋 journalisation.
        
        ⸻
        
        Consentement explicite
        
        En cochant la case ci-dessous et en cliquant sur “J’accepte”, je déclare avoir lu, compris et accepté la politique de confidentialité et les conditions générales d’utilisation de YATA Medical.
        
        [ ] J’accepte les conditions d’utilisation et la politique de confidentialité.
        `,
        termsDescription:
          "Veuillez lire et accepter nos conditions d'utilisation pour continuer.",
        step0: {
          title: "Conditions d'utilisation",
          description: "Accepter les conditions",
          mustAccept: "Vous devez accepter les conditions.",
        },
        step1: {
          title: "Informations essentielles",
          description: "Nom, date de naissance et sexe",
          fullName: {
            label: "Nom complet",
            helperText:
              "Entrez votre nom complet tel qu'il apparaît sur vos documents officiels",
          },
          birthDate: {
            label: "Date de naissance",
            placeholder: "Sélectionnez votre date de naissance",
            helperText:
              "Votre date de naissance nous aide à personnaliser votre expérience médicale",
          },
          gender: {
            label: "Sexe",
            placeholder: "Sélectionnez votre sexe",
            options: {
              homme: "Homme",
              femme: "Femme",
              autre: "Autre",
              placeholder: "Sélectionnez votre sexe",
            },
          },
        },
        step2: {
          sendOTP: {
            button: "Envoyer le code OTP",
            buttonAr: "إرسال رمز OTP",
          },
          title: "Numéro de téléphone",
          description: "Votre numéro de téléphone",
          phoneNumber: {
            label: "Numéro de téléphone",
            placeholder: "Entrez votre numéro de téléphone",
            helperText:
              "Nous utiliserons votre numéro de téléphone pour vous envoyer un code de vérification.",
          },
        },
        step3: {
          title: "Vérification",
          description: "Code de vérification SMS",
          verificationCode: {
            label: "Code de vérification",
            placeholder: "Code de vérification (6 chiffres)",
            helperText: "Un code de vérification a été envoyé au",
            resend: "Renvoyer le code",
            expiration: "Le code expire dans 5 minutes",
          },
        },
        step4: {
          title: "Créer un mot de passe",
          description:
            "Veuillez entrer un mot de passe composé exactement de 4 chiffres.",
          passwordDescription:
            "Veuillez entrer un mot de passe composé exactement de 4 chiffres",
          passwordTips:
            "💡 Conseils: Utilisez au moins 8 caractères, incluez des majuscules, des chiffres et des symboles",
          password: {
            label: "Créer un mot de passe",
            placeholder: "Créer un mot de passe",
            helperText:
              "Veuillez entrer un mot de passe composé exactement de 4 chiffres",
          },
          confirmPassword: {
            label: "Confirmer le mot de passe",
            placeholder: "Confirmer le mot de passe",
          },
          passwordStrength: {
            label: "Force du mot de passe:",
            weak: "Faible",
            medium: "Moyen",
            strong: "Fort",
            veryStrong: "Très fort",
          },
        },
        buttons: {
          requestOtp: {
            label: "Demander Code OTP",
          },
          previous: "Précédent",
          next: "Suivant",
          finish: "Terminer",

          viewTerms: "Voir les conditions",
        },
        notifications: {
          otpVerified: "Code OTP vérifié avec succès",
          otpInvalid: "Code OTP invalide",
          stepCompleted: "Étape complétée!",
          autoProgress: "Passage automatique à l'étape suivante...",
          success: "Inscription réussie ! Bienvenue ✨",
          error: "Une erreur est survenue",
          otpSendFailed: "Le numéro de téléphone existe déjà",
          emailOtpSent: "Code envoyé par email avec succès.",
          emailOtpSendFailed: "Échec de l'envoi du code par email.",
        },
        errors: {
          phone_number_exists: "Ce numéro de téléphone est déjà enregistré.",
        },
        validation: {
          passwordLength:
            "Le mot de passe doit contenir au moins {min} chiffres",
          required: "Ce champ est requis",
          requiredFullName: "Le nom complet est requis",
          requiredGender: "Le genre est requis",
          requiredBirthdate: "La date de naissance est requise",
          minCharacters: "Doit contenir au moins {min} caractères",
          phoneLength:
            "Le numéro de téléphone doit contenir au moins 8 chiffres",
          phoneInvalid: "Numéro de téléphone invalide",
          phonePattern: "Doit contenir 8 chiffres",
          codeLength: "Le code de vérification doit contenir 6 chiffres",
          passwordMatch: "Les mots de passe ne correspondent pas",
          invalidEmail: "Adresse email invalide",
          passwordStrength: {
            label: "Force du mot de passe",
            weak: "Faible",
            medium: "Moyen",
            strong: "Fort",
            veryStrong: "Très fort",
          },
        },
      },
      dataPrivacy: {
        title: "Votre santé. Vos données.",
        subtitle:
          "La protection de vos données personnelles est notre priorité absolue",
        features: [
          {
            title: "Protection des données",
            description:
              "Vos données de santé sont protégées et hébergées dans des clouds certifiés HDS",
          },
          {
            title: "Sécurité renforcée",
            description:
              "Nous utilisons les dernières technologies de cryptage",
          },
          {
            title: "Confidentialité garantie",
            description: "Nous respectons strictement le secret médical",
          },
        ],
      },
      services: {
        title: "Nos Services",
        items: [
          {
            title: "Téléconsultation",
            description:
              "Consultez un médecin en ligne en quelques clics, où que vous soyez.",
          },
          {
            title: "Rendez-vous",
            description:
              "Gérez vos rendez-vous et documents ainsi que ceux de vos proches sur une même application.",
          },
          {
            title: "Biocapteur",
            description:
              "Profitez de capteurs biologiques à domicile pour une télésurveillance médicale continue et de qualité.",
          },
          {
            title: "Soins à domicile",
            description:
              "Réservez des soins à domicile avec facilité, que ce soit pour une infirmière ou un médecin, et bénéficiez de traitements de qualité dans le confort de votre foyer.",
          },
        ],
        button: "En savoir plus",
      },
      appointment: {
        title: "RENDEZ-VOUS",
        paragraph1:
          "Notre service de prise de rendez-vous en ligne simplifie l'accès aux soins médicaux. Plus besoin d'attendre au téléphone ou de vous déplacer, réservez votre consultation quand vous le souhaitez, 24h/24 et 7j/7.",
        paragraph2:
          "Grâce à notre interface intuitive, vous pouvez consulter les disponibilités en temps réel et choisir le créneau qui correspond le mieux à votre emploi du temps.",
        features: [
          {
            title: "Horaires flexibles",
            description:
              "Consultez les disponibilités en temps réel et choisissez le créneau qui vous convient le mieux.",
          },
          {
            title: "Prise de RDV simple",
            description:
              "Réservez votre consultation en quelques clics depuis le confort de votre domicile.",
          },
          {
            title: "Toutes spécialités",
            description:
              "Accédez à une large gamme de spécialités médicales pour tous vos besoins en santé.",
          },
          {
            title: "Suivi intégré",
            description:
              "Gérez tous vos rendez-vous et documents médicaux sur une seule plateforme.",
          },
        ],
      },
      teleconsultation: {
        title: "TÉLÉCONSULTATION",
        paragraph:
          "Modernisez votre accès aux soins de santé grâce à notre service de téléconsultation. Plus besoin de vous déplacer, consultez votre professionnel de santé directement depuis chez vous, en toute sécurité.",
        features: [
          {
            title: "Consultation à distance",
            description:
              "Accédez aux soins médicaux depuis votre domicile via notre plateforme sécurisée de téléconsultation.",
          },
          {
            title: "Flexibilité totale",
            description:
              "Choisissez le moment idéal pour votre consultation et économisez du temps en évitant les déplacements.",
          },
          {
            title: "Interface intuitive",
            description:
              "Profitez d'une plateforme conviviale pour visualiser les créneaux et gérer vos rendez-vous.",
          },
          {
            title: "Sécurité garantie",
            description:
              "Échangez avec votre professionnel de santé en toute confidentialité sur notre plateforme sécurisée.",
          },
          {
            title: "Toutes spécialités",
            description:
              "Accédez à une large gamme de spécialités médicales disponibles en téléconsultation.",
          },
          {
            title: "Confort optimal",
            description:
              "Bénéficiez de consultations de qualité sans quitter le confort de votre domicile.",
          },
        ],
      },
      biocapteurs: {
        title: "BIOCAPTEURS",
        lead: "Surveillez votre santé en temps réel avec des biocapteurs. Mesurez divers indicateurs biologiques pour une détection précoce des changements de santé.",
        devices: [
          {
            title: "Audiogrammes",
            description:
              "Test auditif tonal pour évaluer les pertes auditives. Indiqué pour les plaintes auditives, patients +50 ans, professionnels exposés au bruit et enfants avec retard de langage.",
            indications: [
              "Plaintes auditives",
              "Les patients de plus de 50 ans",
              "Les professionnels exposés au bruit",
              "Les enfants présentant des retards de langage",
            ],
          },
          {
            title: "Holter ECG",
            description:
              "Enregistreur ECG 24h pour détecter les troubles du rythme cardiaque. Examen indolore permettant une surveillance continue pendant vos activités quotidiennes.",
            indications: [
              "L'évaluation de symptômes liés aux arythmies",
              "L'évaluation du risque avec/sans symptômes",
              "L'évaluation de l'efficacité thérapeutique",
              "La détection d'ischémie myocardique",
            ],
          },
          {
            title: "Freestyle Libre 2",
            description:
              "Capteur de glycémie sans piqûre fixé à l'arrière du bras. Transmission en temps réel des données vers votre smartphone.",
            advantages: [
              "Mesure de la glycémie sans piqûre",
              "Suivi en temps réel après les repas et la nuit",
              "Alarmes hypo/hyperglycémie",
              "Rapports détaillés d'évolution",
            ],
          },
        ],
        indicationsLabel: "Indications",
        advantagesLabel: "Avantages",
        more: "En savoir plus",
      },
      helpSection: {
        title: "Des questions ?",
        subtitle: "Consultez notre Centre d'aide ou contactez-nous",
        options: {
          helpCenter: {
            title: "Centre d'aide",
            description: "Trouvez rapidement des réponses à vos questions",
            linkText: "Consulter le centre d'aide",
          },
        },
      },
      footer: {
        contact: "Contact",
        address: "Adresse",
        addressDetails: "Nouakchott, Mauritanie",
        phone: "Téléphone",
        email: "Email",
        ourLocation: "Notre localisation",
        copyright: "Copyright",
      },

      professionalHealth: {
        ePrescription: {
          title: "E-prescription",
          description: `E-prescription par Yata Medical : Une solution innovante pour la gestion des prescriptions médicales

• Prescriptions Médicales
- Base de données complète des médicaments disponibles en Mauritanie
- Prix et informations détaillées sur chaque médicament
- Modèles de prescription personnalisables

• Examens Médicaux
- Création de bulletins d'examen personnalisés
- Modèles préétablis pour une efficacité optimale
- Gestion simplifiée des demandes d'examens

• Documentation Médicale
- Génération de comptes rendus détaillés
- Création de certificats médicaux professionnels
- Archivage sécurisé des documents

• Avantages
- Gain de temps significatif
- Réduction des erreurs de prescription
- Suivi facilité des dossiers patients`,
        },
        imagerie: {
          title: "IMAGERIE MEDICALE",
          description: `Solution d'Imagerie Médicale Avancée

• Types d'Images Supportés
- Radiographie (RX)
- Tomodensitométrie (TDM)
- IRM
- ECG
- Échographie
- OCT

• Caractéristiques Principales
- Visualiseur certifié Europe et FDA
- Système de code QR pour accès rapide
- Compatible multi-supports (téléphone, ordinateur, tablette)

• Fonctionnalités Avancées
- Analyse précise des images
- Partage sécurisé entre professionnels
- Stockage cloud sécurisé
- Annotations et mesures intégrées

• Bénéfices
- Diagnostic plus rapide et précis
- Collaboration médicale facilitée
- Accès instantané aux images
- Suivi patient optimisé`,
        },
        biologie: {
          title: "BIOLOGIE MEDICALE",
          description: `Gestion Intelligente des Analyses Biologiques

• Automatisation
- Synchronisation avec les automates de laboratoire
- Traitement automatisé des résultats
- Validation électronique sécurisée

• Gestion des Résultats
- Accès en temps réel aux analyses
- Interface intuitive pour les professionnels
- Historique complet des examens

• Service Patient
- Consultation sécurisée des résultats en ligne
- Notification SMS automatique
- Accès via code QR et mot de passe

• Avantages
- Optimisation du flux de travail
- Réduction des délais de traitement
- Amélioration de la satisfaction patient
- Traçabilité complète des analyses`,
        },
        rendezVous: {
          title: "RENDEZ VOUS AU CABINET",
          description: `Gestion Optimisée des Rendez-vous Médicaux

• Fonctionnalités Secrétariat
- Création de compte dédié secrétaire
- Gestion complète du planning
- Modification et annulation flexibles
- Notes et informations patients

• Multi-Établissements
- Gestion simultanée de plusieurs sites
- Synchronisation en temps réel
- Vue consolidée des plannings
- Coordination inter-établissements

• Organisation Efficace
- Calendrier intelligent
- Rappels automatiques
- Gestion des priorités
- Suivi des disponibilités

• Bénéfices
- Optimisation du temps médical
- Réduction des rendez-vous manqués
- Meilleure organisation quotidienne
- Communication facilitée`,
        },
        teletravail: {
          title: "TELETRAVAIL",
          description: `Solutions de Télémédecine Complètes

• Téléexpertise
- Collaboration médicale à distance
- Partage sécurisé d'avis médicaux
- Discussions de cas complexes
- Documentation des échanges

• Télésurveillance
- Suivi patient en temps réel
- Alertes personnalisables
- Monitoring des paramètres vitaux
- Intervention précoce facilitée

• Téléconsultation
- Consultations vidéo sécurisées
- Capteurs biomédicaux connectés
- Prescription à distance
- Suivi patient optimisé

• Avantages
- Accessibilité aux soins améliorée
- Réactivité accrue
- Continuité des soins assurée
- Collaboration médicale renforcée`,
        },
      },
    },
  },
  ar: {
    translation: {
      login: "تسجيل الدخول",
      header: "احجز موعدًا مع محترف صحي في موريتانيا",
      search_placeholder: "اسم الطبيب أو التخصص",
      popular_searches: "البحث الشائع",
      download_app: "قم بتنزيل تطبيقنا",
      search_button_text: "بحث",
      hero_header: "حدد موعدًا مع متخصص صحي",
      professional_healthcare: "هل أنت متخصص صحي؟",
      help: "مساعدة",
      loading: "جاري البحث...",
      inscription: {
        datepicker: {
          placeholder: "اختر تاريخك",
          done: "تم",
          cancel: "إلغاء",
          months: [
            "يناير",
            "فبراير",
            "مارس",
            "أبريل",
            "مايو",
            "يونيو",
            "يوليو",
            "أغسطس",
            "سبتمبر",
            "أكتوبر",
            "نوفمبر",
            "ديسمبر",
          ],
        },
        termsTitle: "شروط الاستخدام وسياسة الخصوصية",
        close: "إغلاق",
        iAccept: "أوافق على شروط الاستخدام وسياسة الخصوصية.",
        accept: "قبول",
        decline: "رفض",
        termsAccepted: "لقد قبلت الشروط.",
        termsMustAccept: " يجب أن تقبل الشروط.",
        PRIVACY_TEXT: `✅ إشعار الخصوصية والموافقة المستنيرة للمستخدم

⸻

 المسؤول عن معالجة البيانات

شركة \u2066YATA MEDICAL & SCIENCE SARL\u2069 الطبية والعلوم ش.م.م، المسجلة برقم \u206696819/GU/17828\u2069، ومقرها في سوكو 0279، نواكشوط، هي المسؤولة عن معالجة البيانات ذات الطابع الشخصي التي يتم جمعها عبر هذا التطبيق.

⸻

 أهداف المعالجة

نقوم بجمع ومعالجة بياناتك الشخصية لتقديم خدمات صحية رقمية، تشمل على وجه الخصوص:

- حجز المواعيد الطبية عبر الإنترنت أو في العيادات؛  
- الاستشارات الطبية عن بُعد (التطبيب عن بُعد والتشخيص عن بُعد)؛  
- متابعة المؤشرات الصحية وإدارة ملفك الطبي الإلكتروني (DMP)؛  
- التواصل الآمن مع المهنيين الصحيين المخولين.

⸻

 البيانات التي يتم جمعها

قد تشمل البيانات التي تتم معالجتها ما يلي:

- بيانات التعريف: الاسم، اللقب، رقم الهاتف، البريد الإلكتروني؛  
- البيانات الصحية: التاريخ الطبي، الأعراض، نتائج الفحوصات، المؤشرات الحيوية، العلاجات.

⸻

 الأساس القانوني والموافقة

وفقًا للقانون رقم \u20662017-020\u2069:

- لن تتم معالجة بياناتك إلا بعد موافقتك الحرة والمحددة والمستنيرة والواضحة؛  
- بالنقر على “أوافق”، فإنك تمنح إذنًا صريحًا بمعالجة بياناتك للأغراض المذكورة أعلاه؛  
- يمكنك سحب موافقتك في أي وقت، دون الحاجة إلى تبرير، عبر تبويب "اتصال" أو بإرسال رسالة إلى البريد الإلكتروني: \u2066support@yatamedical.com\u2069

⸻

 الجهات المستفيدة من البيانات

يمكن الوصول إلى بياناتك فقط من قبل:

- المهنيين الصحيين الذين تمنحهم تفويضًا صريحًا من خلال نظام المصادقة لدينا (رمز OTP أو رمز QR)؛  
- الطاقم التقني المخول من \u2066YATA Medical\u2069 لأغراض الصيانة أو الدعم الفني.

لا تتم مشاركة أي بيانات مع أطراف ثالثة غير مخولة، إلا في حال وجود التزام قانوني.

⸻

 نقل البيانات والاستضافة

يتم استضافة البيانات بشكل آمن في مراكز بيانات معتمدة:

- في موريتانيا (للنسخ الاحتياطي)؛  
- في ألمانيا (خوادم \u2066DigitalOcean\u2069 و\u2066Hetzner\u2069) من أجل التشغيل، والتخزين الآمن، وضمان التكرار.

⸻

 مدة الاحتفاظ بالبيانات

تُحتفظ بياناتك الصحية لمدة عشر (10) سنوات وفقًا للمعايير الوطنية. بعد انقضاء هذه المدة، يتم إخفاء هوية البيانات أو حذفها نهائيًا.

⸻

 حقوقك

يمكنك في أي وقت:

- الوصول إلى بياناتك؛  
- تعديلها أو حذفها؛  
- الاعتراض على معالجتها.

لممارسة هذه الحقوق، يُرجى التواصل مع خدمة العملاء لدينا:

- 📞 الهاتف: \u2066+222 244 00 001\u2069  
- 📧 البريد الإلكتروني: \u2066support@yatamedical.com\u2069

⸻

 أمن البيانات

نطبق تدابير أمنية صارمة تشمل:  
🔐 مصادقة قوية، 🔐 تشفير البيانات، 🔒 التحكم في الوصول، 📋 تسجيل العمليات.

⸻

 الموافقة الصريحة

من خلال تحديد المربع أدناه والنقر على “أوافق”، أقر بأنني قرأت وفهمت وأقبل سياسة الخصوصية وشروط الاستخدام الخاصة بشركة \u2066YATA Medical\u2069.

[ ] أوافق على شروط الاستخدام وسياسة الخصوصية.
`,
        termsDescription:
          "يرجى قراءة وقبول شروط الاستخدام الخاصة بنا للمتابعة.",
        stepCounter: {
          currentStep: "الخطوة {{currentStep}} من {{totalSteps}}",
        },
        newTitle: "إنشاء حساب",
        title: "التسجيل",
        passwordTips:
          "💡 نصائح: استخدم على الأقل 8 أحرف، وقم بتضمين حروف كبيرة وأرقام ورموز",
        step0: {
          title: "شروط الاستخدام",
          description: "قبول الشروط",
          mustAccept: "يجب أن تقبل الشروط.",
        },
        step1: {
          title: "المعلومات الأساسية",
          description: "الاسم وتاريخ الميلاد والجنس",
          fullName: {
            label: "الاسم الكامل",
            helperText: "أدخل اسمك الكامل كما يظهر في الوثائق الرسمية",
          },
          birthDate: {
            label: "تاريخ الميلاد",
            placeholder: "اختر تاريخ ميلادك",
            helperText: "تاريخ ميلادك يساعدنا في تخصيص تجربتك الطبية",
          },
          gender: {
            label: "الجنس",
            placeholder: "اختر جنسك",
            options: {
              homme: "ذكر",
              femme: "أنثى",
              autre: "أخرى",
              placeholder: "اختر جنسك",
            },
          },
        },
        step2: {
          sendOTP: {
            button: "Envoyer le code OTP",
            buttonAr: "إرسال رمز OTP",
          },
          title: "رقم الهاتف",
          description: "رقم هاتفك",
          phoneNumber: {
            label: "رقم الهاتف",
            placeholder: "أدخل رقم هاتفك",
            helperText: "سنستخدم رقم هاتفك لإرسال رمز التحقق",
          },
        },
        step3: {
          title: "التحقق",
          description: "رمز التحقق عبر SMS",
          verificationCode: {
            label: "رمز التحقق",
            placeholder: "رمز التحقق (6 أرقام)",
            helperText: "تم إرسال رمز التحقق إلى",
            resend: "إعادة إرسال الكود",
            expiration: "يتم إلغاء صلاحية الكود بعد 5 دقائق",
          },
        },
        step4: {
          title: "إنشاء كلمة المرور",
          description: "يرجى إدخال رمز مكوّن من 4 أرقام",
          passwordDescription: "يرجى إدخال رمز مكوّن من 4 أرقام",
          passwordTips:
            "💡 نصائح: استخدم على الأقل 8 أحرف، وقم بتضمين حروف كبيرة وأرقام ورموز",
          password: {
            label: "إنشاء كلمة المرور",
            placeholder: "إنشاء كلمة المرور",
            helperText: "يرجى إدخال رمز مكوّن من 4 أرقام.",
          },
          confirmPassword: {
            label: "تأكيد كلمة المرور",
            placeholder: "تأكيد كلمة المرور",
          },
          passwordStrength: {
            label: "قوة كلمة المرور:",
            weak: "ضعيف",
            medium: "متوسط",
            strong: "قوي",
            veryStrong: "قوي جدا",
          },
        },
        buttons: {
          requestOtp: {
            label: "طلب رمز OTP",
          },
          previous: "السابق",
          next: "التالي",
          finish: "إكمال",
          viewTerms: "عرض الشروط",
        },
        notifications: {
          otpVerified: "تم التحقق من رمز OTP بنجاح",
          otpInvalid: "رمز OTP غير صالح",
          stepCompleted: "تم إكمال الخطوة!",
          autoProgress: "الانتقال التلقائي إلى الخطوة التالية...",
          success: "تم التسجيل بنجاح! مرحباً ✨",
          error: "حدث خطأ",
          otpSendFailed: "رقم الهاتف موجود بالفعل",
          emailOtpSent: "تم إرسال رمز التحقق عبر البريد الإلكتروني بنجاح.",
          emailOtpSendFailed: "فشل في إرسال رمز التحقق عبر البريد الإلكتروني.",
        },
        errors: {
          phone_number_exists: "رقم الهاتف هذا مسجل بالفعل.",
        },
        validation: {
          passwordLength: "يجب أن يحتوي كلمة المرور على {min} رقم على الأقل",
          required: "هذا الحقل مطلوب",
          requiredFullName: "الاسم الكامل مطلوب",
          requiredGender: "الجنس مطلوب",
          requiredBirthdate: "تاريخ الميلاد مطلوب",
          minCharacters: "يجب أن يحتوي على {min} حرف على الأقل",
          phoneLength: "يجب أن يحتوي رقم الهاتف على 8 أرقام على الأقل",
          phoneInvalid: "رقم الهاتف غير صالح",
          phonePattern: "يجب أن يحتوي على 8 أرقام ",
          codeLength: "يجب أن يحتوي كود التحقق على 6 أرقام",
          passwordMatch: "كلمات المرور لا تتطابق",
          invalidEmail: "البريد الإلكتروني غير صالح",
          passwordStrength: {
            label: "قوة كلمة المرور",
            weak: "ضعيف",
            medium: "متوسط",
            strong: "قوي",
            veryStrong: "قوي جدا",
          },
        },
      },
      download_app_store: "تنزيل من متجر التطبيقات",
      download_google_play: "متاح على متجر جوجل بلاي",
      hero_background_alt: "خلفية طبية",
      certification_text: "معتمد من وزارة الصحة رقم: 00266/2021",
      appPromo: {
        header: "التطبيق رقم 1 لصحتك",
        description:
          "تجعل Yata Medical الوصول إلى الرعاية الصحية سريعًا وسهلاً.",
        rating: "التقييم: 4.7",
        download_ios: "تحميل من متجر التطبيقات",
        download_android: "متاح على متجر جوجل بلاي",
        alt_ios: "تحميل تطبيق Yata Medical من متجر التطبيقات",
        alt_android: "تحميل تطبيق Yata Medical من جوجل بلاي",
        phone_alt: "تطبيق Yata Medical للهاتف المحمول",
      },
      nosTrophees: {
        title: "-جوائزنا-",
        total_award:
          "جائزة أفضل شركة ناشئة في موريتانيا في النسخة الثانية من تحدي STARUPPER DE L'ANNÉE الذي نظمته شركة TOTAL ENERGIE في 52 دولة.",
        ibtikar_award:
          "تم اختيارنا كأكثر شركة ابتكارًا في موريتانيا خلال تحدي IBTIKAR-PRIZE الذي نظمته وزارة التحول الرقمي في نسخة 2022.",
        alt_total: "جائزة Total Energie Startupper",
        alt_ibtikar: "جائزة ابتكار",
      },
      aboutUs: {
        title: "من نحن؟",
        para1:
          "تأسست YATA Médical في عام 2018، وهي أول مزود معتمد للتطبيب عن بُعد في موريتانيا.",
        para2:
          "مهمتنا هي جعل الرعاية الصحية في متناول الجميع، من خلال استخدام الابتكارات الذكية والأدوات التكنولوجية المتقدمة. مع التركيز على ديمقراطية الخدمات الطبية، قمنا بتطوير مجموعة كاملة من أدوات إدارة المستشفيات، مما يوفر حلاً متكاملاً لتحسين كفاءة المؤسسات الصحية.",
      },
      healthcarePartner: {
        title: "شركاؤنا في الرعاية الصحية",
        subtitle: "شبكة موثوقة",
        description:
          "تربط منصتنا المرضى بشبكة واسعة من المتخصصين المؤهلين في الرعاية الصحية. نحن نتعاون عن كثب مع الأطباء والمتخصصين والمؤسسات الصحية لتقديم رعاية عالية الجودة لمرضانا.",
        stats: [
          "طبيب موريتاني مسجل",
          "صور طبية مرفوعة على الإنترنت",
          "استشارات",
          "دعم متوفر 24/7",
        ],
        alt: "شركاؤنا من المهنيين الصحيين",
      },
      dataPrivacy: {
        title: "صحتك. بياناتك.",
        subtitle: "حماية بياناتك الشخصية هي أولويتنا القصوى",
        features: [
          {
            title: "حماية البيانات",
            description:
              "يتم حماية بياناتك الصحية واستضافتها في سحابات معتمدة من HDS",
          },
          {
            title: "أمان معزز",
            description: "نستخدم أحدث تقنيات التشفير",
          },
          {
            title: "ضمان الخصوصية",
            description: "نحترم السرية الطبية بدقة",
          },
        ],
      },
      services: {
        title: "خدماتنا",
        items: [
          {
            title: "الاستشارة عن بُعد",
            description: "استشر طبيبًا عبر الإنترنت ببضع نقرات فقط، أينما كنت.",
          },
          {
            title: "المواعيد",
            description:
              "قم بإدارة مواعيدك ووثائقك ووثائق أحبائك من خلال تطبيق واحد.",
          },
          {
            title: "المستشعرات الحيوية",
            description:
              "استفد من المستشعرات الحيوية في المنزل للمراقبة الطبية المستمرة وعالية الجودة.",
          },
          {
            title: "الرعاية المنزلية",
            description:
              "احجز الرعاية المنزلية بسهولة، سواء لممرضة أو طبيب، واستمتع بالعلاج في راحة منزلك.",
          },
        ],
        button: "اعرف المزيد",
      },
      appointment: {
        title: "المواعيد",
        paragraph1:
          "تُسهل خدمتنا لحجز المواعيد عبر الإنترنت الوصول إلى الرعاية الطبية. لم تعد بحاجة إلى الانتظار على الهاتف أو التنقل، احجز موعدك في أي وقت، 24/7.",
        paragraph2:
          "بفضل واجهتنا البديهية، يمكنك الاطلاع على التوفر في الوقت الفعلي واختيار الوقت الأنسب لك.",
        features: [
          {
            title: "مواعيد مرنة",
            description:
              "اطلع على المواعيد المتاحة في الوقت الفعلي واختر ما يناسبك.",
          },
          {
            title: "حجز سهل",
            description: "احجز موعدك ببضع نقرات فقط من راحة منزلك.",
          },
          {
            title: "جميع التخصصات",
            description:
              "الوصول إلى مجموعة واسعة من التخصصات الطبية لتلبية احتياجاتك الصحية.",
          },
          {
            title: "متابعة متكاملة",
            description: "قم بإدارة جميع مواعيدك ووثائقك الطبية من منصة واحدة.",
          },
        ],
      },

      success: {
        title: "تم انشاء حسابك بنجاح",

        buttons: {
          install: "تنزيل التطبيق",
        },
      },
      teleconsultation: {
        title: "الاستشارة عن بعد",
        paragraph:
          "حدث طريقة وصولك إلى الرعاية الصحية من خلال خدمة الاستشارة عن بعد. لا حاجة للتنقل، تواصل مع طبيبك مباشرة من منزلك بأمان وراحة.",
        features: [
          {
            title: "الاستشارة عن بعد",
            description:
              "احصل على الرعاية الصحية من منزلك عبر منصتنا الآمنة للاستشارة عن بعد.",
          },
          {
            title: "مرونة كاملة",
            description: "اختر الوقت المناسب لك ووفّر وقتك دون الحاجة للتنقل.",
          },
          {
            title: "واجهة سهلة الاستخدام",
            description: "استخدم منصتنا السهلة لعرض المواعيد وإدارتها.",
          },
          {
            title: "أمان مضمون",
            description: "تواصل بأمان وسرية مع طبيبك عبر منصتنا الآمنة.",
          },
          {
            title: "جميع التخصصات",
            description:
              "الوصول إلى مجموعة واسعة من التخصصات الطبية المتوفرة عن بُعد.",
          },
          {
            title: "راحة مثالية",
            description: "استمتع باستشارات طبية عالية الجودة من منزلك.",
          },
        ],
      },
      biocapteurs: {
        title: "أجهزة الاستشعار الحيوية",
        lead: "راقب صحتك في الوقت الفعلي باستخدام أجهزة استشعار حيوية. قم بقياس مؤشرات بيولوجية مختلفة للكشف المبكر عن التغيرات الصحية.",
        devices: [
          {
            title: "مخططات السمع",
            description:
              "اختبار سمع لتقييم فقدان السمع. موجه للمرضى الذين يعانون من شكاوى سمعية، فوق 50 سنة، العاملين في بيئة ضوضاء، أو الأطفال المتأخرين في الكلام.",
            indications: [
              "شكاوى سمعية",
              "المرضى فوق 50 سنة",
              "العاملون في أماكن صاخبة",
              "الأطفال المتأخرون في النطق",
            ],
          },
          {
            title: "هولتر ECG",
            description:
              "جهاز لتسجيل تخطيط القلب لمدة 24 ساعة لكشف اضطرابات نظم القلب. اختبار غير مؤلم يتيح المراقبة أثناء النشاط اليومي.",
            indications: [
              "تقييم الأعراض المرتبطة بعدم انتظام ضربات القلب",
              "تقييم المخاطر مع أو بدون أعراض",
              "تقييم فعالية العلاج",
              "كشف نقص التروية القلبية",
            ],
          },
          {
            title: "فري ستايل ليبر 2",
            description:
              "مستشعر سكر الدم دون وخز، يثبت على الذراع ويرسل البيانات مباشرة إلى هاتفك.",
            advantages: [
              "قياس السكر دون وخز",
              "متابعة في الوقت الفعلي بعد الوجبات وأثناء الليل",
              "تنبيهات للارتفاع والانخفاض",
              "تقارير مفصلة لتتبع الحالة",
            ],
          },
        ],
        indicationsLabel: "الاستعمالات",
        advantagesLabel: "الفوائد",
        more: "المزيد",
      },
      helpSection: {
        title: "هل لديك أسئلة؟",
        subtitle: "اطلع على مركز المساعدة أو تواصل معنا",
        options: {
          helpCenter: {
            title: "مركز المساعدة",
            description: "ابحث عن إجابات لأسئلتك بسرعة",
            linkText: "زيارة مركز المساعدة",
          },
        },
      },

      footer: {
        contact: "اتصال",
        address: "العنوان",
        addressDetails: "نواكشوط ، موريتانيا",
        phone: "هاتف",
        email: "البريد الإلكتروني",
        ourLocation: "موقعنا",
        copyright: "حقوق الطبع والنشر ",
      },
      professionalHealth: {
        ePrescription: {
          title: "الوصفة الإلكترونية",
          description: `الوصفة الإلكترونية من Yata Medical: حل مبتكر لإدارة الوصفات الطبية

• الوصفات الطبية
- قاعدة بيانات شاملة للأدوية المتوفرة في موريتانيا
- الأسعار والمعلومات التفصيلية لكل دواء
- نماذج وصفات طبية قابلة للتخصيص

• الفحوصات الطبية
- إنشاء تقارير فحوصات مخصصة
- نماذج جاهزة لفعالية أفضل
- إدارة مبسطة لطلبات الفحوصات

• الوثائق الطبية
- إنشاء تقارير مفصلة
- إصدار شهادات طبية احترافية
- أرشفة آمنة للوثائق

• الفوائد
- توفير كبير في الوقت
- تقليل أخطاء الوصفات
- متابعة سهلة لملفات المرضى`,
        },
        imagerie: {
          title: "التصوير الطبي",
          description: `حلول متقدمة للتصوير الطبي

• أنواع الصور المدعومة
- الأشعة السينية
- التصوير المقطعي (TDM)
- التصوير بالرنين المغناطيسي (IRM)
- تخطيط القلب (ECG)
- التصوير بالموجات فوق الصوتية
- تصوير العين OCT

• الخصائص الرئيسية
- عارض معتمد أوروبياً وأمريكياً
- نظام QR للوصول السريع
- دعم متعدد الأجهزة (هاتف، كمبيوتر، لوحي)

• الميزات المتقدمة
- تحليل دقيق للصور
- مشاركة آمنة بين الأطباء
- تخزين سحابي آمن
- تعليقات وقياسات مدمجة

• الفوائد
- تشخيص أسرع وأكثر دقة
- تسهيل التعاون الطبي
- وصول فوري للصور
- تحسين متابعة المريض`,
        },
        biologie: {
          title: "البيولوجيا الطبية",
          description: `إدارة ذكية للتحاليل البيولوجية

• الأتمتة
- مزامنة مع أجهزة المختبرات
- معالجة تلقائية للنتائج
- تحقق إلكتروني آمن

• إدارة النتائج
- وصول فوري للتحاليل
- واجهة سهلة الاستخدام للأطباء
- سجل تاريخي كامل للفحوصات

• خدمة المرضى
- مشاهدة آمنة للنتائج عبر الإنترنت
- تنبيهات عبر الرسائل النصية
- دخول باستخدام رمز QR وكلمة مرور

• الفوائد
- تحسين سير العمل
- تقليل وقت المعالجة
- تحسين رضا المرضى
- تتبع كامل للتحاليل`,
        },
        rendezVous: {
          title: "حجز المواعيد",
          description: `إدارة مواعيد طبية فعالة

• سكرتارية
- حساب خاص للسكرتير
- إدارة شاملة للجدول الزمني
- تعديل وإلغاء سهل
- ملاحظات ومعلومات المرضى

• مؤسسات متعددة
- إدارة عدة مواقع في آن واحد
- مزامنة فورية
- عرض موحد للجدول الزمني
- تنسيق بين المؤسسات

• تنظيم ذكي
- تقويم ذكي
- تذكيرات تلقائية
- إدارة الأولويات
- متابعة التوافر

• الفوائد
- تحسين وقت الطبيب
- تقليل الغياب عن المواعيد
- تنظيم يومي أفضل
- تسهيل التواصل`,
        },
        teletravail: {
          title: "العمل عن بعد",
          description: `حلول شاملة للتطبيب عن بعد

• الاستشارة الطبية عن بعد
- تعاون طبي عن بعد
- مشاركة آمنة للآراء الطبية
- مناقشة الحالات المعقدة
- توثيق للمحادثات

• المراقبة عن بعد
- مراقبة المرضى في الوقت الفعلي
- تنبيهات مخصصة
- تتبع العلامات الحيوية
- تسهيل التدخل المبكر

• الاستشارات عن بعد
- فيديو آمن للاستشارة
- أجهزة استشعار طبية متصلة
- وصفات طبية عن بعد
- متابعة المرضى بشكل فعال

• الفوائد
- تحسين الوصول للرعاية
- استجابة أسرع
- ضمان استمرارية الرعاية
- تعزيز التعاون الطبي`,
        },
      },
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "ar",
    interpolation: {
      escapeValue: false,
    },
    lng: localStorage.getItem("lang") || "ar",
  });

export default i18n;
